<template>
    <div class="container-fluid">
        
        <div class="row">
            <div><router-link to="." class="btn btn-second">Назад</router-link></div>
            <!--
            <div> {{ prompt }}</div>
            <div> {{ ApiData }}</div>
            -->
        </div>
        <div v-if="loading">Загружаем</div>
        <div v-else>
            <card>
                <div class="row mt-3">
                    <label class="col-form-label col-md-1"> Активное:</label>
                    <div class="col-md-11"> <input type="checkbox" class="form-control" v-model="prompt.act"/></div>
                </div>
                <div class="row mt-3">
                    <label class="col-form-label col-md-1"> Название:</label>
                    <div class="col-md-11"> <input type="text" class="form-control" v-model="prompt.name"/></div>
                </div>

                <div class="row mt-3">
                    <label class="col-form-label col-md-1 required"> Событие: </label>
                    <div class="col-md-11 form-group">
                        <el-select 
                            class="select-primary mr-2"
                            v-model="prompt.trigger_id" 
                            placeholder="Выберите событие"
                            size="large"
                            filterable
                            clearable
                            @change="changeTrigger"
                        >
                            <el-option
                                class="select-primary"
                                v-for="m of $GVO.cats.cat_ai_triggers"
                                :key="m.trigger_id"
                                :label="m.name"
                                :value="m.trigger_id"
                                >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <p>{{ triggerDescription }}</p>
                <div class="row mt-3" v-if="filters.length>0">
                    <label class="col-form-label col-md-1"> Фильтры: </label>
                    <div class="col-md-11 form-group">
                        <el-select 
                            class="select-primary mr-2"
                            v-model="prompt.filters" 
                            placeholder="Укажите варианты, если запускаем всегда, то не указывайте"
                            size="large"
                            filterable
                            clearable
                            multiple
                        >
                            <el-option
                                class="select-primary"
                                v-for="m of filters"
                                :key="m.id"
                                :label="m.name"
                                :value="m.id"
                                >
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="row mt-3">
                    <label class="col-form-label col-md-1"> Действие:</label>
                    <div class="col-md-11 form-group">
                        <el-select 
                            class="select-primary mr-2"
                            v-model="prompt.result_id" 
                            placeholder="Укажите результат"
                            size="large"
                            filterable
                            clearable
                        >
                            <el-option
                                class="select-primary"
                                v-for="m of $GVO.cats.cat_ai_results"
                                :key="m.result_id"
                                :label="m.name"
                                :value="m.result_id"
                                >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="row mt-3">
                    <label class="col-form-label col-md-12"> <span>Общий текст (добавится после вопроса):</span></label>
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="mb-0">
                                <textarea class="form-control" v-model="prompt.prompt"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="action-buttons row px-3 mt-3">
                    <div v-for="btn in buttons" :key="btn.id">
                        <base-button
                        class="mr-3"
                        :type="btn.type"
                        simple
                        :disabled="btn.disabled"
                        @click="btn.action"
                        >
                            {{ btn.label }}
                        </base-button>
                    </div>
                </div>        
            </card>

            
            <div class="ai-query">
                <card v-for="q in ApiData" >
                    <REAIQuery 
                        :key="q.options.id" 
                        :query="q.options" 
                        :prompt="prompt.prompt"
                        :filterProps="propList"
                        @clone="copyQuery($event)"
                        @remove="removeQuery($event)"
                        @change="updateQuery($event)"
                    />
                </card>
                <card>
                    <base-button type="success" simple  v-on:click="AddQuery()">Добавить вопрос</base-button>
                </card>
            </div>
            
            <card>
                <p>{{ prompt.description }}</p>
                <p>{{ prompt.result }}</p>
                <div class="action-buttons row px-3 mt-3">
                    <div v-for="btn in buttons" :key="btn.id">
                        <base-button
                        class="mr-3"
                        :type="btn.type"
                        simple
                        :disabled="btn.disabled"
                        @click="btn.action"
                        >
                        {{ btn.label }}
                        </base-button>
                    </div>
                </div>
            </card>    
        </div>    
    </div>
</template>
<script>
import REAIQuery, { formatQuery } from './REAIQuery.vue';
import { Select, Option } from 'element-ui';

    export default {
        components:{
            REAIQuery,
            [Option.name]: Option,
            [Select.name]: Select,            
        },
        data(){
            return {
                loading: true,
                ApiData:[],
                prompt:{
                    prompt:'',
                    description: '',
                    filters: [],
                    result: null,
                    trigger_id: 0,
                    act: 1,
                    result_id: 0,
                },
                filters:[],
                buttons: [
                    { id: 'save', label: 'Сохранить', type: 'success', action: this.save },
                    { id: 'download', label: 'Скачать', type: 'primary', action: this.download },
                    { id: 'import', label: 'Импортировать', type: 'danger', action: this.runImport },
                ],
            };
        },
        computed: {
            id() {
                return this.$route.params.id;
            },
            propList(){
                let list=[];
                this.ApiData.forEach(q=>{
                    q.options.props.forEach(p=>{
                        let t=p.name.trim();
                        if(t>'' && list.indexOf(t)===-1)
                        list.push(t);
                    })
                });
                return list;
            },
            triggerDescription(){
                if(this.prompt && this.prompt.trigger_id && this.$GVO.cats.cat_ai_triggers){
                    const f = this.$GVO.cats.cat_ai_triggers.find(c=>c.trigger_id==this.prompt.trigger_id)
                    if(f) return f.description;
                }
                return undefined;
            }
        },
        methods:{
            changeTrigger(){
                this.prompt.filters=[];
                this.updateTriggers();
            },
            updateTriggers(){
                this.filters = this.getTriggerFilters();
            },
            getTriggerFilters(){
                const triggerId = this.prompt.trigger_id;
                if (!triggerId) return [];
                if(!this.$GVO.cats.cat_ai_triggers) return [];
                const trigger =  this.$GVO.cats.cat_ai_triggers.find(m => m.trigger_id == triggerId)
                if(!trigger) return [];
                const filters =  trigger.filters;
                if(filters){
                    if (!filters || typeof filters !== 'string') return [];

                        try {
                        const parsed = JSON.parse(filters);

                        // Если объект, преобразуем key-value в массив объектов
                        if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                            return Object.keys(parsed).map(key => ({
                            id: key,
                            name: parsed[key]
                            }));
                        }

                        // Если уже массив
                        if (Array.isArray(parsed)) {
                            return parsed.map(item => ({
                                id: item.key || item.id,
                                name: item.value || item.name
                            }));
                        }

                        return [];
                        } catch (error) {
                        console.error('Ошибка парсинга JSON:', error);
                        return [];
                        }
                }else{
                    return [];
                }
            },
            async save(){
                if(!this.prompt.trigger_id) return this.$GVO.showAlert('Ошибка полей','Не заполнено событие');
                if(!this.prompt.result_id) return this.$GVO.showAlert('Ошибка полей','Не заполнено действие');
                let props={
                    flt:{
                        id: this.id
                    },
                    uData:{
                        ...this.prompt,
                        data: this.ApiData.map((p,i)=>({...p, sort_index:i, formated:formatQuery(p.options, this.prompt.prompt)}))
                    }
                };
                // console.log(props);                alert(JSON.stringify(props));asdgsgd();
                let r= await this.$GVO.Api.AI.prompt_query_save(props);
                // console.log('res', r);
                if(r.success==true){
                    this.$router.push({path:"."});
                }else{
                    this.$GVO.showAlert('Ошибка сохранения',r.msg);
                }
            },
            async loadCats(){
                this.$GVO.LoadCatPromise('cat_ai_results');
                await this.$GVO.LoadCatPromise('cat_ai_triggers');
                this.updateTriggers();
            },
            async load(){
                const result = await this.$GVO.Api.AI.prompts_query({flt:{id:this.id}});
                if(result.success==true){
                    this.ApiData = result.data.map(row=>{
                        let tmp;
                        try{
                            tmp = JSON.parse(row.options);
                        }catch(e){
                            tmp = {}
                        }

                        row.options = {...{active:true, text:'', filters:[], props:[]}, ...tmp}
                        if(!row.options.id) row.options.id = this.$GVO.getId();
                        return row;
                    });
                    if(result.prompt){
                        this.prompt = result.prompt;
                        this.prompt.name && window.dispatchEvent(new CustomEvent('update-title', {
                            detail: { title: this.prompt.name }
                        }))         
                        this.updateTriggers();               
                    }

                }
                this.loading = false;
            },
			AddQuery(text){
                this.ApiData.push({
                    id:null,
                    options:{
                        id: this.$GVO.getId(),
                        text:text||'',
                        props:[],
                        filters:[],
                        active: true,
                    
                    }
                })
            },            
            updateQuery(query) {
                // console.log('update', query)
                const index = this.ApiData.findIndex(item => item.options.id === query.id);
                if (index !== -1) {
                    // Заменяем объект целиком — это важно для реактивности в Vue 2
                    this.$set(this.ApiData, index, {...this.ApiData[index], options:query});
                    // или: this.query.splice(index, 1, query);
                }
            },
            removeQuery(q) {
                const index = this.ApiData.findIndex(item => item.options.id === q.id);
                if (index === -1) return;
                // Создаём новый массив без элемента (иммутабельно)
                this.ApiData = [
                    ...this.ApiData.slice(0, index),
                    ...this.ApiData.slice(index + 1)
                ];
            },

            copyQuery(q) {
                // console.log('clone',q,this.ApiData)
                const index = this.ApiData.findIndex(item => item.options.id === q.id);
                if (index === -1) return;

                // Клонируем объект (предполагается, что $GVO.unlinkObject делает глубокую копию)
                const nq = this.$GVO.unlinkObject(this.ApiData[index]);
                // console.log(nq);
                nq.id=null;
                nq.options.id = this.$GVO.getId(); // новый уникальный ID

                // Вставляем копию ПЕРЕД оригиналом (или после — как вам нужно)
                this.ApiData = [
                    ...this.ApiData.slice(0, index),
                    nq,
                    ...this.ApiData.slice(index) // вставляем перед → оригинальный остаётся на своём месте
                ];
            },
            getSaveData(){
                let ai = {
                    id: this.id,
                    data: this.ApiData,
                    query: this.ApiData.map(p=>p.options),
                    prompt: this.prompt.prompt,
                }
                return ai;
            },
            download(){
                const ai = this.getSaveData();
                // Преобразуем объект в JSON с отступами для читаемости (опционально)
                const jsonStr = JSON.stringify(ai, null, 2);
                
                // Создаём Blob с типом application/json
                const blob = new Blob([jsonStr], { type: 'application/json' });
                
                // Генерируем временный URL
                const url = URL.createObjectURL(blob);
                
                // Создаём ссылку для скачивания
                const a = document.createElement('a');
                a.href = url;
                a.download = `ai-text-${this.id}.json`; // Имя файла при скачивании
                
                // Добавляем в DOM, кликаем и удаляем
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                
                // Освобождаем память
                URL.revokeObjectURL(url);
            },
            runImport(){
                this.$GVO.showPrompt('Загрузите настройки','содержимое файла').then(result=>{
					if(result.value){
                        try{
                            this.loadConfig(result.value);
                        }catch(e){
							this.$GVO.showAlert('Ошибка',`Не удалось прочитать настройки`);
						}
					}
				})
            },
            loadConfig(config){
                let ai = JSON.parse(config);
                if(ai){
                    if(ai.id && ai.id != this.id) return this.$GVO.showAlert('ошибка!','Вы загрузили правила для другого вопроса.\nВо избежании проблем загрузка была остановлена');
                    if(Object.prototype.hasOwnProperty.call(ai,'data')) this.ApiData = ai.data;
                    if(Object.prototype.hasOwnProperty.call(ai,'prompt')) this.prompt.prompt = ai.prompt;
                }
            },
        },
        mounted(){
            this.loadCats();
            this.load();
        }
    }
</script>